const TOKENS_STORAGE_KEY = 'openJobsReferralTokens';
const REFER_INTENT = 'refer';

export const REFERRAL_TOKEN_QUERY_PARAM = 'referral';
export const OPEN_REFER_FORM_QUERY_PARAM = 'refer';

function readTokens() {
	try {
		const parsed = JSON.parse(window.localStorage.getItem(TOKENS_STORAGE_KEY));
		return parsed && typeof parsed === 'object' && !Array.isArray(parsed)
			? parsed
			: {};
	} catch {
		return {};
	}
}

function writeTokens(tokens) {
	try {
		window.localStorage.setItem(TOKENS_STORAGE_KEY, JSON.stringify(tokens));
	} catch {
		// Private mode / quota: the email link still carries the token.
	}
}

export function getStoredReferralToken(jobId) {
	const token = readTokens()[Number(jobId)];
	return typeof token === 'string' && token ? token : null;
}

export function storeReferralToken(jobId, token) {
	const id = Number(jobId);
	if (!id || !token) return;
	writeTokens({ ...readTokens(), [id]: token });
}

export function clearReferralToken(jobId) {
	const tokens = readTokens();
	delete tokens[Number(jobId)];
	writeTokens(tokens);
}

export function buildReferSignInPath(jobId) {
	return `/login?intent=${REFER_INTENT}&jobId=${Number(jobId)}`;
}

export function buildReferFormPath(jobId) {
	return `/jobs/${Number(jobId)}?${OPEN_REFER_FORM_QUERY_PARAM}=1`;
}

export function getReferIntentJobId(search) {
	const params = new URLSearchParams(search || '');
	if (params.get('intent') !== REFER_INTENT) return null;
	const jobId = parseInt(params.get('jobId'), 10);
	return Number.isInteger(jobId) && jobId > 0 ? jobId : null;
}

// Runs in the sign-in tab once the session exists. When the Job tab that
// opened it is still around, that tab continues the referral on its own.
export function finishReferSignIn(history, jobId) {
	const opener = window.opener;
	if (opener && !opener.closed) {
		window.close();
	}
	history.push(buildReferFormPath(jobId));
}
